module.exports = __webpack_public_path__ + "static/media/playspace_section1.8302f685.png";